<template>
  <section class="cx-sec m-exp-filter">
    <div class="cx-wrap--page m-wrap--page">
      <div class="cx-row">
        <div class="cx-col-md-5 cx-col-lg-6 cx-col-xl-7 m-exp-filter__head">
          <div class="m-exp-fitler__head-text">
            <div class="cx-div">
              <h2 :aria-label="$t('home.topTourHeading_1')" class="cx-t20 m-exp-filter__title"
                v-html="`${$t('home.topTourHeading_1')}<br>${$t('home.topTourHeading_2')}`"
              ></h2>
            </div>
            <div class="cx-div">
              <router-link-localed class="cx-link m-exp-filter__seeall" to="/macao-full-of-fun">
                <span class="cx-link__icon"><i class="fa-2x fal fa-route"></i></span>
                <span class="cx-link__text">{{$t('trip.seeAllTrips')}}</span>
              </router-link-localed>
            </div>
          </div>
          <div class="m-exp-filter__head-graphic" :class="{ 'bnw-gray': blackAndWhite }">
            <cx-img
              tag='i'
              class='m-graphic--tour'
              imgSrc='/static/graphic/mgto_graphic_toptour.png'
            ></cx-img>
          </div>
        </div>
        <div class="cx-col-md-7 cx-col-lg-6 cx-col-xl-5 m-exp-filter__toptour">          
            <cx-slider-v2 barPager cycling loop>
              <cx-slider-item v-for="idx in slideNum" :key="idx">
                <template slot-scope="slotProps">
                  <div class="m-toptour__herotitle">
                    <div class="cx-t02">
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star fa-2x"></i>
                      <i class="fas fa-star"></i>
                    </div>
                    <div>Tour</div>
                  </div>
                  <!-- <div class="m-toptour__bg"></div> -->
                  <div class="cx-row--halfgutter">
                    <div v-for="tour in tours.groups.slice(4 * (idx - 1), 4 * idx)"
                      :key="tour.name"
                      class="cx-col-xs-6 cx-div m-toptour__item">
                      <component
                        @focus.native="slotProps.focusHandler"
                        @blur.native="slotProps.blurHandler"
                        :is="''"
                        v-bind="linkProps(tour.link || `/${tour.category || tours.category}/${tour.group}`)" 
                      >
                        <div class="cx-media">
                          <cx-img class="cx-media__img -round-corner"
                            tag="div"
                            :imgSrc="getMediaHost(tour.thumbnail, 'MGTO_MEDIA')"
                            lazyLoad
                          >
                            <div class="cx-media__caption cx-t10 m-toptour__title"></div>
                            <div class="cx-media__caption cx-t20" 
                              style="white-space: pre-wrap"
                              v-if="tour.nameMultiLine"
                            >{{tour.nameMultiLine}}</div>
                            <h3 v-else class="cx-media__caption cx-t20">{{tour.name}}</h3>
                          </cx-img>
                        </div>
                      </component>
                    </div>
                  </div>
                </template>
              </cx-slider-item>
            </cx-slider-v2>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'home-top-tour',
  uit() {
    return [
      ['home', [
        'topTourHeading_1',
        'topTourHeading_2'
      ]],
      ['trip', [
        'seeAllTrips'
      ]]
    ]
  },
  data() {
    return {
      startIdx: 0,
    }
  },
  computed: {
    ...mapState({
      blackAndWhite: state => state.ui.blackAndWhite,
    }),
    tours() {
      // return this.$store.getters['toptour/getTours'](this.$i18n.locale) || []
      return this.$store.getters['sightmap/getOverview'](
        'tour-macao-full-of-fun',
        this.$i18n.locale
      ) || {groups:[]};
    },
    slideNum() {
      return Math.ceil(this.tours.groups.length / 4);
    }
  }
}
</script>

<style lang="scss">
  .m-exp-filter{
    @media (min-width:$breakpoint-md) {
      padding-top: 0;
    }
    @media (max-width:$breakpoint-md) {
      .cx-col-md-5{
        margin-bottom: $space-base;
      }      
    }
    &__title{
      @extend %style-title;
    }
    &__head{
      .m-graphic--tour{
        @include pos-abs-full;
        background-position: left bottom;
        @media (max-width:$breakpoint-md) {
          position: static;
          height: 150px;
          margin-top: -$space-sm !important;
          background-position: center bottom;
        }
      }
      @media (min-width:$breakpoint-md) {
        margin-top: $space-xl;
        display: flex;
        flex-direction: column;
      }      
    }
    &__seeall{
      @extend %style-text-link;
    }
    &__head-text{
      flex: 3;
    }
    &__head-graphic{
      flex: 7;
      position: relative;
    }
    &__toptour{
      @media (max-width:2000px) {
        @include set-font(.8);
      }       
      @media (max-width:$breakpoint-lg) {
        @include set-font(.7);
      } 
      @media (max-width:$breakpoint-sm) {
        @include set-font(.6);
      }      
      @media (min-width:$breakpoint-md) {
        margin-top: -$space-xl !important;
      }
      .cx-div:nth-child(odd){
        .cx-media__caption:nth-child(even){
          display: flex;
          &:after{
            display: inline-block;
            // width: 30%;
            height: 20px;
            // content: "";
          }
        }        
      }
      .cx-div:nth-child(even){
        text-align: right;
        .cx-media__caption:nth-child(even){
          display: flex;
          &:before{
            display: inline-block;
            // width: 25%;
            height: 20px;
            content: "";
            flex: 1;
          }
        }         
      }
      .cx-div:nth-child(3){
        margin-bottom: 0;
      }
    }
    .cx-row--halfgutter{
      @media (max-width: $breakpoint-sm) {
        margin-left: -$space-xs;
        margin-right: -$space-xs;
      }      
    } 
  }
  .m-toptour{
    &__bg{
      border-radius: 50%;
      position: absolute;
      width: 50%;
      height: 50%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: $color-yellow;
      z-index: -1;
    }
    &__herotitle{
      background-color: $color-yellow;
      text-transform: uppercase;
      font-weight: bold;
      text-align: center;
      width: 20%;
      height: 20%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 100;
      background-repeat: no-repeat;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      white-space: nowrap;
      border: $space-sm solid $color-white;
      @media (min-width: $breakpoint-sm){
        border: $space-base solid $color-white;
      }
      & > div:last-child{
        letter-spacing: -3px;
        line-height: 1.1;
        padding-bottom: $space-sm;
        font-size: 2em;
        @media (min-width: $breakpoint-sm){
          padding-bottom: $space-base;
          font-size: 2.5em;
        }
        @media (min-width: $breakpoint-lg){
          font-size: 3em;
        }
      }
      &:before{
        content: "";
        border-radius: 50%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border: 2px solid $color-yellow;
        width: calc(100% + #{$space-lg});
        height: calc(100% + #{$space-lg});
        @media (min-width: $breakpoint-sm){
          width: calc(100% + #{$space-xl});
          height: calc(100% + #{$space-xl});
        }        
      }     
      // background-image: url(/static/graphic/title_trips_en.svg);
    }
    &__item{
      text-align: left;
      text-shadow: 0 0 .75em rgba(#000000, .5);
      font-family: $font-condensed;
      @media (max-width: $breakpoint-sm) {
      padding-left: $space-xs !important;
      padding-right: $space-xs !important;
      margin-bottom: $space-sm !important;
      }
      .cx-media__caption:nth-child(odd){
        display: none;
      }
      .cx-media__caption:nth-child(even){
        @media (max-width: $breakpoint-sm) {
          padding: $space-sm;
        } 
      }
      &:nth-child(3){
        .cx-media__caption{
          padding-right: $space-xl;
        }
      }
      &:nth-child(4){
        .cx-media__caption{
          padding-left: $space-xl;
        }
      }       
    }
  }
</style>
